// extracted by mini-css-extract-plugin
module.exports = {"fixSocialElem":"CRUmg","fixSocial":"sULlk","fixSocialTop":"LTjqd","background":"_aWAs"};